import { faLock, faSignIn } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, LoadingOverlay, Paper, Stack, Text, TextInput, Title } from '@mantine/core';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { NAV } from '../../../config/navigation';
import { formPaperHeadingStyle, formPaperStyle, formPaperStyleLarge } from '../../login/styles';
import { useMediaQuery } from '@mantine/hooks';
import { UseFormReturnType } from '@mantine/form';
import { UseMutationResult } from 'react-query';
import { IErrorObject } from '../../../services/types';
import { ISetPasswordFormProps } from '../types';
import Alert from '../../../component/common/alert';
import { useEffect } from 'react';

interface FormProps extends ISetPasswordFormProps {
  confirmPassword: string;
}

interface SetPasswordFormProps {
  hookForm: UseFormReturnType<FormProps>;
  onSetPassword: UseMutationResult<void, IErrorObject, ISetPasswordFormProps, void>;
}

export default function ResetPasswordForm({ hookForm, onSetPassword }: SetPasswordFormProps) {
  const form = hookForm;
  const { mutate, isError, error, isLoading, isSuccess } = onSetPassword;
  const largeScreen = useMediaQuery('(min-width: 800px)');
  const navigate = useNavigate();
  const search = useLocation().search;
  const code = new URLSearchParams(search).get('code');

  const handleSubmit = ({ password }: ISetPasswordFormProps) => {
    mutate({ resetCode: code || '', password });
  };

  useEffect(() => {
    if (isSuccess) {
      navigate(`/login`);
    }
  }, [isSuccess, navigate]);

  return (
    <Paper withBorder shadow={'md'} sx={largeScreen ? formPaperStyleLarge : formPaperStyle}>
      <Title align="center" order={2} styles={formPaperHeadingStyle}>
        Set Password
      </Title>

      {isError && <Alert mt="1rem" message={error?.error?.message} />}

      <form onSubmit={form.onSubmit(values => handleSubmit(values))}>
        <Stack spacing={10} mt="3rem">
          <LoadingOverlay visible={isLoading} />

          <TextInput
            type="password"
            {...form.getInputProps('password')}
            label="Password"
            placeholder="password"
            icon={<FontAwesomeIcon icon={faLock} />}
          />
          <TextInput
            type="password"
            {...form.getInputProps('confirmPassword')}
            label="Confirm Password"
            placeholder="confirm password"
            icon={<FontAwesomeIcon icon={faLock} />}
          />

          <Button type="submit" px={50} mt="lg">
            Set Password
          </Button>
        </Stack>
        <Text size="sm" mt={'lg'}>
          <FontAwesomeIcon icon={faSignIn} style={{ paddingRight: '0.5rem' }} />
          Already signed up?
          <div>
            <Text<typeof Link> component={Link} to={NAV.LOGIN} underline size="sm" color="#228be6" pl={'3px'}>
              Click here to log in
            </Text>
          </div>
        </Text>
      </form>
    </Paper>
  );
}
